import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import FunctionConfig from './functionConfig'; // 库存取值设置
import CategoryConfig from '@/views/components/categoryConfig/categoryConfig.vue'; // 分类配置
import NewDisplayConfig from '@/views/components/newDisplayConfig';
import MiniPage from '@/views/components/miniPage/miniPage';
import ProductManager from '@/views/components/productManager';
import CouponsManager from '@/views/components/couponsManager';
import CornerMask from '@/views/components/cornerMark';

@Component({
  components: {
    CategoryConfig,
    NewDisplayConfig,
    MiniPage,
    ProductManager,
    FunctionConfig,
    CouponsManager,
    CornerMask,
  },
})
export default class SiteConfig extends Vue {
  // 运营模式 1 镜单 2 镜千 3 云单 4 云千
  @Prop()
    mode: number | string;

  // 网点名称
  @Prop()
    siteName: string;

  curPage = '0';

  mounted() {
    this.curPage = this.$route.params.page;
  }

  render(h) {
    return (
      <div class="contentWrapper">
        <div class="breadCrumbBar">
          <span class="firstClassMenu">
            <router-link to="/siteManage">店铺管理</router-link>
          </span>
          /<span>{this.$store.state.siteName}</span>
        </div>
        <div class="contentBody">
          <div class="pageNav">
            <el-menu default-active={this.curPage} mode="horizontal" onSelect={val => (this.curPage = val)}>
              <el-menu-item index={'1'}>商品管理</el-menu-item>
              <el-menu-item index={'5'}>券上下架</el-menu-item>
              <el-menu-item index={'2'}>分类配置</el-menu-item>
              <el-menu-item index={'6'}>角标配置</el-menu-item>
              <el-menu-item index={'3'}>店铺装修</el-menu-item>
              <el-menu-item index={'4'}>微页面</el-menu-item>
              <el-menu-item index={'7'}>功能配置</el-menu-item>

              {/* <el-menu-item index={"5"}>设定</el-menu-item> */}
            </el-menu>
          </div>
          <div class="unitWrapper">
            {this.curPage === '1' && <ProductManager />}
            {this.curPage === '2' && <CategoryConfig />}
            {this.curPage === '3' && <NewDisplayConfig sgId={+this.$route.params.sgId} />}
            {this.curPage === '4' && <MiniPage />}
            {this.curPage === '5' && <CouponsManager />}
            {this.curPage === '6' && <CornerMask />}
            {this.curPage === '7' && <FunctionConfig mode={this.mode || this.$route.params.mode} />}
          </div>
        </div>
      </div>
    );
  }
}
